import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Card,
  CardBody,
  Progress,
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
} from 'reactstrap';
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import { FaArrowLeft, FaArrowRight, FaRedo, FaCheck } from 'react-icons/fa';
import { requestQuizFromAI } from "../../services/RobotAIServices.js";
import QuizComponent from "components/Quiz/QuizComponent.js";
import NavigationButton from "components/NavigationButton/NavigationButton.js";



const QuizLessonPage = () => {

  const mainRef = useRef(null);

  const [quizCompletedFlag, setQuizCompletedFlag] = useState(false);



  const completedLessons = [
    "What Is JavaScript?",
    "Where Does JavaScript Run?",
    "How to Write and Run JavaScript",
    "Comments in JavaScript",
    "Basic Syntax of JavaScript",
    "Indentation",
    "Naming Conventions",
    "Semicolons",
  ];



  useEffect(() => {

  }, []);



  return (


    <>
      {/* The navbar sits before <main>, not inside it. */}
      <div className="  lessonMain  h-100vh " >
        <LessonNavBar />
        <main id="main" tabIndex={-1} className="lessonMain">
          <section>
            <QuizComponent completedLessonList={completedLessons} setQuizCompletedFlag={setQuizCompletedFlag} />
          </section>
          <section className=" lessonBackgroundColor1">
            <Container className="container-lg">
              <Row className=" p-3   align-items-center  justify-content-between">
                <NavigationButton direction="back" page="" ></NavigationButton>
                {quizCompletedFlag == true && (
                  <NavigationButton direction="next" page="" ></NavigationButton>
                )}
              </Row>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
}



export default QuizLessonPage;